import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Sheet } from "@/ui/Sheet/Sheet";
import { CheckIcon, CloseIcon } from "@/assets/icons";
import {
  MAX_PICKS,
  SERVICES,
  SERVICE_ORDER,
  TARIFF_LABEL,
  pickId,
  pickLabel,
} from "@/features/services";
import { useProfileStore } from "@/store/profile";
import cls from "./TariffSheet.module.scss";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const TariffSheet: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const picks = useProfileStore((s) => s.picks);
  const togglePick = useProfileStore((s) => s.togglePick);
  const [shake, setShake] = useState(0);

  const full = picks.length >= MAX_PICKS;
  const isOn = (k: string, tr: string) => picks.some((p) => p.k === k && p.t === tr);

  const title = (
    <>
      {t("sheet.tariffs")}
      <span className={classNames(cls.badge, full && cls.badgeAcc)}>
        {t("sheet.count", { n: picks.length, max: MAX_PICKS })}
      </span>
    </>
  );

  return (
    <Sheet isOpen={isOpen} onClose={onClose} title={title}>
      <div className={classNames(cls.chosen, shake && cls.shake)} key={shake}>
        {picks.length ? (
          picks.map((p) => (
            <button
              key={pickId(p)}
              type="button"
              className={cls.pchip}
              onClick={() => togglePick(p)}
            >
              <i style={{ background: SERVICES[p.k].color }} />
              {pickLabel(p)}
              <CloseIcon />
            </button>
          ))
        ) : (
          <span className={cls.none}>{t("sheet.none")}</span>
        )}
        {full && <div className={cls.hint}>{t("sheet.maxHint")}</div>}
      </div>

      {SERVICE_ORDER.map((k) => {
        const svc = SERVICES[k];
        return (
          <div className={cls.grp} key={k}>
            <div className={cls.head}>
              <span className={cls.lg}>
                <img src={svc.logo} alt="" />
              </span>
              {svc.name}
            </div>
            {svc.tariffs.map((tr) => {
              const on = isOn(k, tr);
              const off = !on && full;
              return (
                <button
                  key={tr}
                  type="button"
                  className={classNames(cls.row, on && cls.on, off && cls.off)}
                  onClick={() => {
                    if (togglePick({ k, t: tr }) === "full") setShake((n) => n + 1);
                  }}
                >
                  <span className={cls.box}>{on && <CheckIcon />}</span>
                  <span className={cls.tx}>{TARIFF_LABEL[tr]}</span>
                </button>
              );
            })}
          </div>
        );
      })}
    </Sheet>
  );
};
